module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ranking-list"
  }, [_c('transition-group', {
    attrs: {
      "tag": "ul",
      "name": "list"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.name
    }, [_c('div', {
      staticClass: "id"
    }, [_vm._v(_vm._s(item.ranking))]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('webp-image', {
      attrs: {
        "src": item.icon,
        "alt": item.name,
        "width": "100%",
        "height": "100%"
      }
    }), _vm._v(">\n      ")], 1), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "course"
    }, [_vm._v(_vm._s(_vm.duration2course(item.duration)))]), _vm._v("节\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-3bd40abb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RankingList.vue
// module id = 203
// module chunks = 1